module.exports = __webpack_public_path__ + "img/open_link.8e250ea4.png";